import React from 'react';
import { TypedMemo } from '../../modules/common/types';
import { SMLAppNavigationRoutes } from './SMLAppNavigationRoutes';
import { SmartLinksContainer } from '../../modules/smartLinks/smartLinksContainer/SmartLinksContainer';
import { SMLRootWrapper } from '../SMLRootWrapper';
import { SMLRouter } from '../smlHistory';
import { Alerts } from '../../utils/AlertServices/Alerts';
import { WhatsNewHost } from '../../modules/music24/whatsNew/WhatsNewHost';

const SMLAppNavigationComponent: React.FC = () => {
  return (
    <SMLRouter>
      <Alerts />
      <SmartLinksContainer>
        <SMLRootWrapper>
          <SMLAppNavigationRoutes />
          {/* The What's new panel (on Home). The update toast is appUpdate/AppUpdateNotice. */}
          <WhatsNewHost />
        </SMLRootWrapper>
      </SmartLinksContainer>
    </SMLRouter>
  );
};
export const SMLAppNavigation = TypedMemo(SMLAppNavigationComponent);
